export default __webpack_public_path__ + "static/media/undraw_graduation.8099321a.svg";